import { Injectable } from '@angular/core';
import { CompanyEditSSOProvider } from 'src/AngularJS/Admin/Company/company-edit-sso.model';
import { CVApiService } from 'src/app/reusables/services/cv-api.service';

@Injectable({
    providedIn: 'root'
})
export class CompanyEditSSOService {
    private SsoOptions?: Map<string, CompanyEditSSOProvider>;

    constructor(private cvApiService: CVApiService) { }

    public async getSsoOptions(): Promise<Map<string, CompanyEditSSOProvider>> {
        if (this.SsoOptions)
            return this.SsoOptions;

        try {
            let response = await this.cvApiService.get<Map<string, CompanyEditSSOProvider>>(`/sso-auth/sso-options`);
            if (response.status_code >= 200 && response.status_code < 300) {
                this.SsoOptions = new Map(Object.entries(response.data));
                this.SsoOptions.forEach(provider => {
                    provider.Protocols = new Map(Object.entries(provider.Protocols));
                });
                return this.SsoOptions;
            }
            else throw response;
        }
        catch (err) {
            console.error(`Failed getting SSO options.`);
            throw err;
        }
    }

    public cleanSecurityCertificate(cert: string): string {
        if (!!cert)
            cert = cert.replace('-----BEGIN CERTIFICATE-----', '')
                .replace('-----END CERTIFICATE-----', '')
                .replace('\n', '')
                .replace('\r', '');

        return cert;
    }
}
